//import { SSL_OP_ALLOW_UNSAFE_LEGACY_RENEGOTIATION } from "constants";
//import moment from 'moment';

class DateHelper{
    addYears(date,years){
        return new Date(date.getFullYear() + parseInt(years,10),date.getMonth(),date.getDate());
    }
    addDays(date,days){
        if(date){
            return new Date(date.getTime() + 24*60*60*1000*days);
        }else{
            return null;
        }
    }
    addHours(date,hours){
        return new Date(date.getTime() + 60*60*1000*hours);
    }
    addFiscalYear(date,years){
        return this.addDays(this.addYears(date,years),-1);
    }
    
    toShortDate(dateStr){
        if(!dateStr){
            return '';
        }
        var date = new Date(dateStr);
        return   (date.getMonth() + 1) + '/' + date.getDate()+ '/' + (date.getFullYear() - 2000);
    }
    toShortDateOrOriginal(dateStr) {
        if (!dateStr) {
            return '';
        }
        var date = new Date(dateStr);
        if (date.getMonth()) {
            return (date.getMonth() + 1) + '/' + date.getDate() + '/' + (date.getFullYear() - 2000);
        } else {
            return dateStr;
        }
    }
    toShortDateRange(StartStr,EndStr){
        if(!StartStr){
            return '';
        }
        return this.toShortDate(StartStr) + '-' + this.toShortDate(EndStr);
    }
    pad(number) {
        if ( number < 10 ) {
          return '0' + number;
        }
        return number;
      }
   
     toESTString(dateStr) {
        if(!dateStr){
            return ''
        }
        let dt = new Date(dateStr);
        return dt.getFullYear() +
          '-' + this.pad( dt.getMonth() + 1 ) +
          '-' + this.pad( dt.getDate() ) +
          'T' + this.pad( dt.getHours() ) +
          ':' + this.pad( dt.getMinutes() )
    };

    toESTDateString(dateStr) {
        if(!dateStr){
            return ''
        }
        let dt = new Date(dateStr);
        return dt.getFullYear() +
          '-' + this.pad( dt.getMonth() + 1 ) +
          '-' + this.pad( dt.getDate() ) 
    };

    toESTString2(dateStr) {
        if(!dateStr){
            return ''
        }
        let dt = new Date(dateStr);
        return dt.getFullYear() +
          '-' + this.pad( dt.getMonth() + 1 ) +
          '-' + this.pad( dt.getDate() ) +
          'T' + this.pad( dt.getHours() ) +
          ':' + this.pad( dt.getMinutes() ) +
          ':' + this.pad( dt.getSeconds() ) +
          '.' + (dt.getMilliseconds() / 1000).toFixed(3).slice(2, 5) +
          'Z';
    };

    isMoreThanOneDay(start,end){
        if(!start){
            return false;
        }
        if(!end){
            return false;
        }
        start = this.toDate(start);
        end = this.toDate(end);
        const span = end.getTime() - start.getTime();
        //alert(span);
        const result = span >= 24*60*60*1000;
        //alert(result);
        return result;
    }
    toShortDateTime(dateStr) {
        if (dateStr === null) {
            return null;
        }
        let date = new Date(dateStr);
        return   (date.getMonth() + 1) + '/' + date.getDate() + '/' + (date.getFullYear() - 2000) + '   ' + date.getHours() + ':' + date.getMinutes();
    }
    isWithinTwoWeeks(d) {
        if (!d) {
            return false;
        }
        d = new Date(d);
        let now = new Date();
        let span = d.getTime() - now.getTime();
        if (span < 14 * 24 * 60 * 60 * 1000 && span >= 0) {
            return true;
        }
        return false;
    }
    isWithinEightHours(d) {
        const minutes = this.howManyMinutesToNow(d);
        if (!minutes) {
            return false;
        }
        if (minutes < 8 * 60 && minutes >= 0) {
            return true;
        } else {
            return false;
        }
    }
    isWithinPastThreeDays(d) {
        const minutes = this.howManyMinutesToNow(d);
        if (!minutes) {
            return false;
        }
        if (minutes < 0 && minutes >= -3 * 24 * 60) {
            return true;
        } else {
            return false;
        }
    }
    howManyMinutesToNow(d) {
        if (!d) {
            return null;
        }
        d = new Date(d);
        let now = new Date();
        let span = d.getTime() - now.getTime();
        return span / (1000 * 60);
    }
    howLongToNow(d) {
        const minutes = this.howManyMinutesToNow(d);
        if (!minutes) {
            return null;
        }
        if (minutes < 60) {
            return Math.round(minutes) + ' Mins';
        } else if (minutes < 24 * 60) {
            return Math.round(minutes / 60) + ' Hours';
        } else {
            return Math.round(minutes / (24 * 60)) + ' Days';
        }
    }
    compare(obj1,obj2){
        if(!obj1){
            return 0;
        }
        if(!obj2){
            return 0;
        }
        const d1 = new Date(obj1);
        const d2 = new Date(obj2);
        if(d1 > d2){
            return 1;
        }else if(d1 < d2){
            return -1;
        }else{
            return 0;
        }
    }
}

export default new DateHelper();